module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-N-patch.f2036b8b.png";